import React from "react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import CompanyAvatarIcon from "./CompanyAvatarIcon";

function CompanyAvatar() {
  return (
    <>
      <Avatar icon={<CompanyAvatarIcon />} />
    </>
  );
}

export default CompanyAvatar;
